import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import api, { errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Loader2, XCircle } from "lucide-react";

export default function MagicLogin() {
  const { token } = useParams();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [state, setState] = useState("pending"); // pending | error
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const r = await api.post(`/auth/magic-login/${token}`);
        if (r.data.joined_teams?.length) {
          localStorage.setItem("welcomeTeams", JSON.stringify(r.data.joined_teams));
        }
        setUser(r.data.user);
        nav("/dashboard", { replace: true });
      } catch (err) {
        setState("error");
        setError(errMsg(err, "Sign-in link is invalid or expired"));
      }
    })();
  }, [token, nav, setUser]);

  return (
    <div className="min-h-screen">
      <Header />
      <main id="main" tabIndex={-1} className="max-w-md mx-auto px-6 py-16 text-center">
        <div className="marquee-tag mb-4">// MAGIC SIGN-IN</div>
        {state === "pending" && (
          <>
            <Loader2 size={48} className="mx-auto mb-6 animate-spin" />
            <h1 className="font-display font-black type-title tracking-tighter mb-2">SIGNING YOU IN…</h1>
            <p className="text-ink-muted">Validating your magic link.</p>
          </>
        )}
        {state === "error" && (
          <div data-testid="magic-error">
            <XCircle size={56} className="mx-auto mb-6 text-ink-muted" strokeWidth={1.5} />
            <h1 className="font-display font-black type-title tracking-tighter mb-2">LINK EXPIRED.</h1>
            <p className="text-ink-muted mb-6">{error}</p>
            <Link to="/forgot" className="brutal-btn mt-2 inline-flex">Request a new link</Link>
          </div>
        )}
      </main>
    </div>
  );
}
